// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__1sXs5","header":"MessagesList_header__aN5pP","chat":"MessagesList_chat__1CFXE"};